import React from 'react';

import { h, Component } from "preact";
export default class ActionButton extends Component {
    render() {
        const {onClick, icon, title} = this.props;
        return (
            <a className={'action-btn'} onClick={onClick} title={title}><i
                className={icon}
            />
            </a>
        )
    }
}



// WEBPACK FOOTER //
// ./components/app/ActionButton.js